<template>
  <header class="header">
    <nav class="nav-wrapper">
      <div class="logo">{{ sysTitle }}</div>
      <div class="nav">
        <span
          v-for="nav in navList"
          :key="nav.navId"
          class="nav-item"
          :class="{
            active: activeNav === nav.navId && currentNavLevel == 1,
          }"
          @click="choiceNav(nav)"
        >
          <span>{{ nav.label }}</span>
          <ul
            class="change-skin"
            v-if="nav.navId == 11"
            v-show="mouseHoverNav == 11"
          >
            <li>
              <div
                @click.stop="choiceSkin = 1"
                style="background: linear-gradient(90deg, #43b9ee, #205bc0)"
              >
                <span
                  v-if="choiceSkin == 1"
                  style="color: #43b9ee"
                  class="el-icon-check"
                ></span>
              </div>
            </li>
            <li>
              <div
                @click.stop="choiceSkin = 2"
                style="background: linear-gradient(90deg, #df4557, #5d0b1d)"
              >
                <span
                  v-if="choiceSkin == 2"
                  style="color: #df4557"
                  class="el-icon-check"
                ></span>
              </div>
            </li>
            <li>
              <div
                @click.stop="choiceSkin = 3"
                style="background: linear-gradient(90deg, #f0bf4f, #d69a0d)"
              >
                <span
                  v-if="choiceSkin == 3"
                  style="color: #f0bf4f"
                  class="el-icon-check"
                ></span>
              </div>
            </li>
            <li>
              <div
                @click.stop="choiceSkin = 4"
                style="background: linear-gradient(90deg, #685143, #37271d)"
              >
                <span
                  v-if="choiceSkin == 4"
                  style="color: #37271d"
                  class="el-icon-check"
                ></span>
              </div>
            </li>
          </ul>
        </span>
      </div>
      <div class="right-box">
        <span class="time">{{ timeStr }}</span>
        <span class="nav-item" @click="goNotice">公告</span>
        <span class="nav-item" @click="changeLines">线路</span>
        <span class="nav-item" @click="showZHZL">资料</span>
        <!-- <span class="money"
          >{{ $store.state.user && $store.state.user.balance }}RMB</span
        > -->
        <span class="avatar" @click="handleShowUserInfo">
          <div class="avatar-icon"></div>
        </span>
      </div>
    </nav>
    <div class="sub-nav">
      <span
        class="sub-nav-item"
        :class="{
          active:
            item.code === $store.state.currentSubNav && currentNavLevel == 2,
        }"
        @click="handleSubNavClick(item)"
        v-for="item in subNavList"
        :key="item.code"
      >
        {{ item.name }}
      </span>
      <!-- <div class="game-info">
        <span style="margin-right: 10px">{{
          gameInfo && gameInfo.openQihao
        }}</span>
        <span>距离封盘：</span>
        <span class="active-text">{{ timeOutText }}</span>
      </div> -->
    </div>

    <el-drawer
      class="user-info-drawer"
      :visible.sync="userInfoVisible"
      @close="$emit('exit-close')"
      :size="300"
    >
      <template slot="title">
        <div class="user-info">
          <div class="username">
            {{ $store.state.user && $store.state.user.username }}
          </div>
          <div class="balance">
            {{ $store.state.user && $store.state.user.balance }}RMB
          </div>
        </div>
      </template>
      <div class="user-info-content">
        <div class="group">
          <span class="item" @click="showZHZL">
            <!-- <img class="icon" src="" /> -->
            <i style="margin-right: 10px" class="fa fa-user"></i>
            <span>账户资料</span>
          </span>
          <span class="item" @click="showMemberLog">
            <!-- <img class="icon" src="" /> -->
            <i style="margin-right: 10px" class="fa fa-credit-card"></i>
            <span>账户日志</span>
          </span>
          <span class="item" @click="goNotice">
            <i style="margin-right: 10px" class="fa fa-volume-up"></i>
            <span>公告</span>
          </span>
        </div>
        <div class="group">
          <div class="title">设定</div>
          <span class="item" style="position: relative">
            <!-- <i style="margin-right: 10px" class="fa fa-volume-up"></i> -->
            <span style="margin-right: 50px">下注语音</span>
            <el-switch
              style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
              "
              v-model="isVoice"
              @change="switchVoice"
            ></el-switch>
          </span>
          <span class="item theme">
            <img class="icon" src="" />
            <span>系统主题</span>
            <span
              style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
              "
            >
              <span
                class="theme-item"
                :class="{ active: choiceSkin == 1 }"
                @click="choiceSkin = 1"
              ></span>
              <span
                class="theme-item"
                :class="{ active: choiceSkin == 2 }"
                @click="choiceSkin = 2"
              ></span>
              <span
                class="theme-item"
                :class="{ active: choiceSkin == 3 }"
                @click="choiceSkin = 3"
              ></span>
              <span
                class="theme-item"
                :class="{ active: choiceSkin == 4 }"
                @click="choiceSkin = 4"
              ></span>
            </span>
          </span>
          <span class="item" @click="changePassword">
            <img class="icon" src="" />
            <span>修改密码</span>
          </span>
          <span class="item">
            <img class="icon" src="" />
            <span>赔率设定</span>
          </span>
        </div>
        <div class="group">
          <div class="title">其他</div>
          <span class="item" @click="changeLines">
            <img class="icon" src="" />
            <span>线路检测</span>
          </span>
          <span class="item" @click="choiceNav({ navId: 'wfgz' })">
            <img class="icon" src="" />
            <span>玩法规则</span>
          </span>
          <span class="item" @click="choiceNav({ navId: 'kjhm' })">
            <img class="icon" src="" />
            <span>开奖结果</span>
          </span>
          <span class="item">
            <img class="icon" src="" />
            <span>系统需求</span>
          </span>
          <span class="item">
            <img class="icon" src="" />
            <span>规则与条款</span>
          </span>
          <span class="item">
            <img class="icon" src="" />
            <span>联系我们</span>
          </span>
        </div>
        <div class="logout-btn btn primary" @click="handleLogout">退出登录</div>
      </div>
    </el-drawer>
  </header>
</template>

<script>
export default {
  data() {
    return {
      sysTitle: sessionStorage.getItem("title"),
      isVoice: false,
      mouseHoverNav: -1,
      choiceSkin: 1,
      navList: [
        {
          navId: "xzmx",
          label: "下注明细",
        },
        {
          navId: "lszd",
          label: "历史账单",
        },
        // {
        //   navId: 2,
        //   label: "期期报表",
        //   icon: "/img/index/icon/2.png",
        //   activeIcon: "/img/index/icon/2_active.png",
        // },
        {
          navId: "jsbb",
          label: "结算报表",
        },
        {
          navId: "kjhm",
          label: "开奖号码",
        },
        // {
        //   navId: 5,
        //   label: "信用资料",
        //   icon: "/img/index/icon/5.png",
        //   activeIcon: "/img/index/icon/5_active.png",
        // },
        // {
        //   navId: 6,
        //   label: "玩法规则",
        //   icon: "/img/index/icon/6.png",
        //   activeIcon: "/img/index/icon/6_active.png",
        // },
        // {
        //   navId: 7,
        //   label: "会员日志",
        //   icon: "/img/index/icon/7.png",
        //   activeIcon: "/img/index/icon/7_active.png",
        // },
        // {
        //   navId: 11,
        //   label: "更换皮肤",
        //   icon: "/img/index/icon/11.png",
        //   activeIcon: "/img/index/icon/11_active.png",
        // },
        // {
        //   navId: 8,
        //   label: "线路切换",
        //   icon: "fa fa-exchange",
        //   activeIcon: "/img/index/icon/8_active.png",
        // },
        // {
        //   navId: 9,
        //   label: "安全退出",
        //   icon: "/img/index/icon/9.png",
        //   activeIcon: "/img/index/icon/9_active.png",
        // },
      ],
      subNavList: [
        {
          name: "一字定",
          code: "yzd",
        },
        {
          name: "二字定",
          code: "ezd",
        },
        {
          name: "快打",
          code: "kd",
        },
        {
          name: "快选",
          code: "kx",
        },
        {
          name: "快译",
          code: "ky",
        },
        {
          name: "赔率变动表",
          code: "plbdb",
        },
        {
          name: "txt导入",
          code: "txtdr",
        },
      ],
      userInfoVisible: false,
      now: new Date(),
      timer: null,
      countDowntimer: null,
      openCode: "",
      timeOut: "",
      kaiJiangTimeOut: "",
      currentNavLevel: 2,
    };
  },
  props: ["activeNav", "gameInfo", "initFinished"],
  watch: {
    choiceSkin(newVal) {
      this.setSkin(newVal);
    },
    initFinished(newVal) {
      if (newVal) {
        this.initData();
      }
    },
    gameInfo(newVal) {
      if (newVal) {
        this.initData();
      }
    },
  },
  computed: {
    timeOutText() {
      let timeStr = "00:00:00";
      if (this.timeOut > 0) {
        let seconds = (this.timeOut * 1) % 60;
        let minutes = Math.floor((this.timeOut * 1) / 60);
        seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
        minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
        timeStr = `00:${minutes}:${seconds}`;
      }
      return timeStr;
    },
    timeStr() {
      let hover = this.now.getHours();
      hover = hover < 10 ? `0${hover}` : hover;
      let min = this.now.getMinutes();
      min = min < 10 ? `0${min}` : min;
      let sec = this.now.getSeconds();
      sec = sec < 10 ? `0${sec}` : sec;
      return `${hover}:${min}:${sec}`;
    },
  },
  mounted() {
    this.$BUS.$on("setSkin", (skin) => {
      this.choiceSkin = skin;
      this.setSkin(skin);
    });
    this.getNow();
    this.initData();
  },
  methods: {
    changeLines() {
      this.$emit("changeLines");
      this.userInfoVisible = false;
    },
    changePassword() {
      this.$emit("changePassword");
      this.userInfoVisible = false;
    },
    async switchVoice(type) {
      type = type ? "open" : "";
      let isplayer = 0;
      let isVoice = false;
      if (type == "open") {
        isplayer = 1;
        isVoice = true;
      }

      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        isplayer,
      };

      let result = await this.$http.postAxiosMethod("/user/audioswitch", data);
      if (result) {
        this.isVoice = isVoice;
        sessionStorage.setItem("isplayer", isplayer);
      }
    },
    showMemberLog() {
      this.$emit("choiceNav", "hyrz");
      this.userInfoVisible = false;
    },
    showZHZL() {
      this.$emit("choiceNav", "zhzl");
      this.userInfoVisible = false;
    },
    goNotice() {
      this.$emit("showNotice");
      this.userInfoVisible = false;
    },
    initData() {
      this.getGameInfo();
      setTimeout(() => {
        this.isVoice = sessionStorage.getItem("isplayer") == "1";
      }, 500);
    },
    countDown() {
      if (this.countDowntimer) {
        clearInterval(this.countDowntimer);
      }
      const _this = this;
      this.countDowntimer = setInterval(() => {
        if (_this.timeOut > 0) {
          _this.timeOut--;
        } else if (_this.timeOut == 0) {
          _this.timeOut = -1;
        }
        if (_this.timeOut == 0) {
          _this.$emit("fengpan");
        }
        _this.kaiJiangTimeOut--;
        if (_this.kaiJiangTimeOut <= 0) {
          clearInterval(_this.countDowntimer);
          setTimeout(() => {
            _this.$emit("updateGameInfo");
            _this.$emit("kaijiang");
          }, 500);
        }
      }, 1000);
    },
    getGameInfo() {
      if (this.initFinished && this.gameInfo) {
        this.openCode = this.gameInfo.openCode.split(",");
        this.timeOut = this.gameInfo.closeTime;
        this.kaiJiangTimeOut =
          this.gameInfo.nextTime - this.gameInfo.serverTime;

        if (
          this.gameInfo.nextQihao.substr(
            this.gameInfo.nextQihao.length - 4,
            3
          ) == "001" &&
          this.gameInfo.openQihao.substr(
            this.gameInfo.openQihao.length - 4,
            3
          ) != "288"
        ) {
          setTimeout(() => {
            this.$emit("updateGameInfo");
          }, 5000);
        } else if (this.gameInfo.openQihao != this.gameInfo.nextQihao * 1 - 1) {
          setTimeout(() => {
            this.$emit("updateGameInfo");
          }, 5000);
        }

        // if(this.gameInfo.isClose == 0){
        //     this.timeOut = this.gameInfo.closeTime
        // }else {
        //     this.timeOut = (this.gameInfo.nextTime - this.gameInfo.serverTime)
        // }
        this.countDown();
      }
    },
    getNow() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.now = new Date();
      this.timer = setTimeout(() => {
        this.getNow();
      }, 1000);
    },
    handleLogout() {
      this.$emit("exit");
    },
    handleShowUserInfo() {
      this.userInfoVisible = true;
    },
    handleSubNavClick(nav) {
      this.currentNavLevel = 2;
      this.$store.state.currentSubNav = "";
      setTimeout(() => {
        this.$store.state.currentSubNav = nav.code;
      }, 10);
    },
    choiceNav(nav) {
      this.currentNavLevel = 1;
      this.$emit("choiceNav", nav.navId);
      this.userInfoVisible = false;
    },
    async setSkin(skin) {
      this.choiceSkin = skin;
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let data = {
        access_token,
        uid,
        skinNo: skin,
      };
      let result = await this.$http.postAxiosMethod("/user/setskin", data, {
        hideLoading: true,
      });
      if (result.code == 0) {
        if (skin == 1) {
          document.documentElement.setAttribute("data-theme", "green");
        } else if (skin == 2) {
          document.documentElement.setAttribute("data-theme", "red");
        } else if (skin == 3) {
          document.documentElement.setAttribute("data-theme", "blue");
        } else if (skin == 4) {
          document.documentElement.setAttribute("data-theme", "orange");
        }
      }
      // document.documentElement.setAttribute("data-theme", "brown");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  //   width: 1230px;
  .nav-wrapper {
    position: relative;
    height: 50px;
    color: var(--new-text-primary-bg);
    background: var(--new-bg-primary);
    display: flex;
    align-items: center;
    font-size: 14px;
    .logo {
      margin-left: 50px;
      font-size: 18px;
      line-height: 50px;
    }
    .nav {
      margin-left: 50px;
      line-height: 50px;
      .nav-item {
        margin: 0 20px;
        cursor: pointer;
        &.active {
          color: var(--new-text-primary-bg-active);
        }
      }
    }
    .right-box {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      > .time {
      }
      > span {
        margin: 0 10px;
        cursor: pointer;
      }
      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--new-primary-second-color);
        .avatar-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .sub-nav {
    position: relative;
    padding-left: 210px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #000;
    background: var(--new-bg-white);
    .sub-nav-item {
      position: relative;
      height: 100%;
      line-height: 40px;
      margin: 0 20px;
      cursor: pointer;
      &.active {
        color: var(--new-text-active);
      }
    }

    .game-info {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--primary-table-header-color);
      font-weight: bold;
    }
  }
}
</style>
